export enum CountryAlphaCodes {
  Australia = 'AU',
  Ireland = 'IE',
  UnitedKingdom = 'GB'
}
